module.exports = __webpack_public_path__ + "c89e3ef7aa0455a1258c8d3478fb7fcc.jpg";